"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDevourStatsResponseToJSON = exports.GetDevourStatsResponseFromJSONTyped = exports.GetDevourStatsResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetDevourStatsResponseFromJSON(json) {
    return GetDevourStatsResponseFromJSONTyped(json, false);
}
exports.GetDevourStatsResponseFromJSON = GetDevourStatsResponseFromJSON;
function GetDevourStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (0, _1.GetDevourStatsResponseDataFromJSON)(json['data']),
    };
}
exports.GetDevourStatsResponseFromJSONTyped = GetDevourStatsResponseFromJSONTyped;
function GetDevourStatsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, _1.GetDevourStatsResponseDataToJSON)(value.data),
    };
}
exports.GetDevourStatsResponseToJSON = GetDevourStatsResponseToJSON;
